import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { ArrowRight, Bed, Bathtub, Resize, MapPin } from "@phosphor-icons/react";

export default function PropertyCard({ property, lang }) {
  const { t } = useI18n();
  const title = lang === "en" ? property.title_en : property.title_it;

  return (
    <Link
      to={`/properties/${property.id}`}
      data-testid={`property-card-${property.id}`}
      className="group card-elegant block bg-white"
    >
      <div className="img-zoom relative aspect-[4/3] overflow-hidden bg-[#0A1428]/5">
        <img
          src={property.image}
          alt={title}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute top-4 left-4 bg-[#0A1428] text-white text-xs uppercase tracking-widest px-3 py-1.5 font-semibold">
          {t.properties.filters[property.type] || property.type}
        </div>
      </div>
      <div className="p-6 lg:p-7">
        <div className="flex items-center gap-2 text-[#4A5568] text-sm mb-3">
          <MapPin size={14} className="text-[#C5A059]" />
          <span>{property.location}</span>
        </div>
        <h3 className="font-serif text-2xl text-[#0A1428] leading-tight font-medium group-hover:text-[#C5A059] transition-colors min-h-[60px]">
          {title}
        </h3>

        <div className="flex flex-wrap gap-4 mt-5 text-sm text-[#4A5568]">
          {property.bedrooms > 0 && (
            <span className="flex items-center gap-1.5">
              <Bed size={16} className="text-[#C5A059]" /> {property.bedrooms}
            </span>
          )}
          {property.bathrooms > 0 && (
            <span className="flex items-center gap-1.5">
              <Bathtub size={16} className="text-[#C5A059]" /> {property.bathrooms}
            </span>
          )}
          <span className="flex items-center gap-1.5">
            <Resize size={16} className="text-[#C5A059]" /> {property.area_sqm} m²
          </span>
        </div>

        <div className="mt-6 pt-5 border-t border-[#0A1428]/10 flex items-center justify-between">
          <span className="font-serif text-2xl text-[#0A1428] font-semibold">
            {property.price}
          </span>
          <span className="flex items-center gap-2 text-xs uppercase tracking-widest font-semibold text-[#C5A059]">
            {t.properties.viewDetails} <ArrowRight size={14} weight="bold" />
          </span>
        </div>
      </div>
    </Link>
  );
}
